import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"position":"absolute","top":"10px"}
}

import { computed } from 'vue';

interface Props {
  options: {
    label: string;
    value: string;
  }[];
  pastSdf: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PastSdfileSelects',
  props: {
    options: {},
    pastSdf: {}
  },
  emits: ['selectPastSdf'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

// 過去SDF選択値
const selectPastSdf = computed({
  get: () => props.pastSdf,
  set: (value) => {
    emit('selectPastSdf', value || '');
  },
});

return (_ctx: any,_cache: any) => {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, {
    modelValue: selectPastSdf.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectPastSdf).value = $event)),
    options: props.options,
    outlined: "",
    dense: "",
    clearable: "",
    "emit-value": "",
    "map-options": "",
    style: {"background":"var(--q-white)"}
  }, {
    "no-option": _withCtx(() => [
      _createVNode(_component_q_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "text-grey" }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" 該当するSDFileはありません ")
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (!selectPastSdf.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[2] || (_cache[2] = [
            _createElementVNode("span", { class: "text-dark" }, "選択してください", -1)
          ])))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue", "options"]))
}
}

})